import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMediaType } from '../../../store/mediaSlice';
import TailwindSelect from '../../tailwind/TailwindSelect';

export const MediaSelector = ({ disabled = false }) => {
    const dispatch = useDispatch();
    const { mediaType } = useSelector((state) => state.media);

    const handleMediaTypeChange = (value) => {
        dispatch(setMediaType(value));
    };

    return (
        <div className="space-y-2">
            <label className="text-sm font-medium text-gray-900 dark:text-white">
                Media Type <span className="text-gray-400 font-normal">(Optional)</span>
            </label>
            <TailwindSelect
                items={[
                    { value: 'none', label: 'None' },
                    { value: 'image', label: 'Image' },
                    { value: 'video', label: 'Video' },
                    { value: 'document', label: 'Document' },
                    { value: 'audio', label: 'Audio' },
                ]}
                value={mediaType}
                onChange={handleMediaTypeChange}
                disabled={disabled}
                triggerClassName="w-full bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400">Select the type of media to include in your template. Actual media will be submitted during send message.</p>
        </div>
    );
};

export default MediaSelector;
